import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "handshake",
  "use": "handshake-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"handshake\"><path d=\"M26.61 22.76a3 3 0 000-4.24l1.12-1.13A3 3 0 0028.3 14l3-3-8.9-8.9-2.95 3a3 3 0 00-3.45.57 3 3 0 00-3.41-.58l-2.95-3L.74 11l3 3a3 3 0 00.57 3.4l1.79 1.82a3 3 0 000 4.25l5.66 5.65a3 3 0 004.24 0 3 3 0 004.24 0zM5 12.44L3.56 11l6.08-6 1.41 1.41zM22.36 5l6.08 6L27 12.44l-6-6.07zm-4.95 2.08a1 1 0 011.42 0l7.48 7.49a1 1 0 010 1.41l-1.12 1.12-6.78-6.78a1 1 0 00-.7-.29 1 1 0 00-.71.29l-3.83 3.83a1 1 0 01-.79.29 1 1 0 01-.74-.42 1.1 1.1 0 01.19-1.36zm-2.82 20.63a1 1 0 01-1.42 0l-5.66-5.66a1 1 0 010-1.41l1.42-1.42a1 1 0 011.41 0L16 24.88a1 1 0 010 1.41zm4.24 0a1 1 0 01-1.42 0 3 3 0 000-4.24l-5.65-5.66a3 3 0 00-4.24 0L5.69 16a1 1 0 010-1.41l7.48-7.49a1 1 0 011.42 0l-4.17 4.17a3.09 3.09 0 00-.4 3.94 3 3 0 004.57.38l3.12-3.13 7.48 7.49a1 1 0 010 1.41z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/handshake.svg
// module id = 6tDV
// module chunks = 39 44